import ArachnaApi from "./requests/arachna-api";
export default (config) => {
    return ArachnaApi.getInstance().request.post(`/logging/call/post`, Object.assign({}, config === null || config === void 0 ? void 0 : config.data));
};
